import React from "react";

import Typography from "@mui/material/Typography";

import { FormattedMessage } from "@mnemonic/intl";
import { PageLayout, Section } from "@mnemonic/mui";

import { ArgusMobileFooter } from "./ArgusMobileFooter";

interface ILoginBoxProps {
  children: React.ReactNode;
  loading?: boolean;
}

const LoginBox = ({ children, loading }: ILoginBoxProps) => {
  return (
    <PageLayout
      PageHeaderProps={{
        content: (
          <Typography variant="h6">
            <FormattedMessage id="login.authentication" defaultMessage="Authentication" />
          </Typography>
        ),
      }}
    >
      <Section loading={loading} sx={({ spacing }) => ({ maxWidth: spacing(80), m: "auto" })}>
        <Section.Content>{children}</Section.Content>
        <ArgusMobileFooter />
      </Section>
    </PageLayout>
  );
};

export default LoginBox;
